/**
 * Utility constants related to multiple propagation constraints.
 */
import { mapValues } from 'lodash';

export const TYPE_INFO = {
  EQUAL_TO: {
    key: 'EQUAL_TO',
    symbol: '=',
  },
  NOT_EQUAL_TO: {
    key: 'NOT_EQUAL_TO',
    symbol: '≠',
  },
};

export const TYPES = Object.values(TYPE_INFO).map(t => t.key);
export const SYMBOLS = mapValues(TYPE_INFO, t => t.symbol);
